import { render, staticRenderFns } from "./UserMgm.vue?vue&type=template&id=52d91b5f&scoped=true&"
import script from "./UserMgm.vue?vue&type=script&lang=ts&"
export * from "./UserMgm.vue?vue&type=script&lang=ts&"
import style0 from "./UserMgm.vue?vue&type=style&index=0&id=52d91b5f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d91b5f",
  null
  
)

export default component.exports